import React, { Component } from "react";
import styled from "styled-components";
import BotAvatar from "./BotAvatar";
import ChattyProductItem from "./ChattyProductItem";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const CompWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
`;

const BubbleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  & > .bubble {
    background-color: ${props =>
      props.bot ? "rgba(214,185,161,0.50)" : "#CCA37B"};
    border-radius: 17px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 7px 9px;
    max-width: 316px;
    margin-top: 4px;

    @media screen and (max-width: 479px) {
      max-width: 259px;
    }

    & > p {
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 1.4px;
      color: ${props => (props.bot ? "#000" : "#fff")};
    }

    & > .system-btn {
      width: 161px;
      height: 22px;
      background-color: #fff;
      margin: 3.5px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      cursor: pointer;

      & > p {
        font-size: 13px;
        color: #b08963;
        letter-spacing: 1.3px;
      }
    }
  }
`;

class ChattyProductResult extends Component {
  render() {
    const results = [
      {
        comp: <ChattyProductItem />
      },
      {
        comp: (
          <BubbleWrapper bot>
            <div className="bubble">
              <p>另外這兩個你也可以考慮看看</p>
            </div>
          </BubbleWrapper>
        )
      },
      {
        comp: <ChattyProductItem />
      },
      {
        comp: <ChattyProductItem />
      },
      {
        comp: (
          <BubbleWrapper bot>
            <div className="bubble">
              <p>
                希望我有幫上你的忙囉～如果滿意這次的配對結果，可以按「配對結果存至我的帳號」
              </p>
            </div>
          </BubbleWrapper>
        )
      },
      {
        comp: (
          <BubbleWrapper bot>
            <div className="bubble">
              <p>如果你想再做一次測驗，可以按下面的「重做配對」按鈕</p>
            </div>
          </BubbleWrapper>
        )
      },
      {
        comp: (
          <BubbleWrapper bot>
            <div className="bubble">
              <div className="system-btn">
                <p>配對結果存至我的帳號</p>
              </div>
              <div className="system-btn">
                <p>重做配對</p>
              </div>
            </div>
          </BubbleWrapper>
        )
      }
    ];

    return (
      <Wrapper>
        {results.map((item, idx) => {
          return (
            <CompWrapper>
              <BotAvatar isLast={idx === results.length - 1} />
              {item.comp}
            </CompWrapper>
          );
        })}
      </Wrapper>
    );
  }
}

export default ChattyProductResult;
